import { isFailedAndReport } from '@/api/helper'
import { withDialogLoading } from '@/utils/task'
import { ElForm } from 'element-ui/types/form'
import { Vue, Component, Prop, Ref } from 'vue-property-decorator'

function makeForm() {
    return {
        oriPassword: '',
        newPassword: '',
        confirmNewPassword: '',
    }
}

@Component({
    name: 'MotifyPassword'
})
export class MotifyPasswordImpl extends Vue {
    form = makeForm()

    validateConfirmNewPassword(rule, value, callback) {
        if (value !== this.form.newPassword) {
            callback(new Error(this.$t('account.missmatchPassword') as string));
        } else {
            callback();
        }
    }

    get Rules() {
        return {
            oriPassword: [
                { required: true, message: this.$t('account.pleaseInputOrigPassword'), trigger: 'blur' },
            ],
            newPassword: [
                { required: true, message: this.$t('account.pleaseInputNewPassword'), trigger: 'blur' },
            ],
            confirmNewPassword: [
                { required: true, message: this.$t('account.pleaseInputConfirmNewPassword'), trigger: 'blur' },
                { validator: this.validateConfirmNewPassword, trigger: 'blur' }
            ],
        }
    }

    @Ref()
    formRef: ElForm

    onConfirm() {
        const buildTask = async () => {
            const validated = await this.$validateElForm(this.formRef)
            if (!validated) {
                return
            }
            const {
                oriPassword,
                newPassword
            } = this.form
            const res = await this.$api.system.userMotifyPassword({
                oriPassword,
                newPassword,
            })
            if (isFailedAndReport(this, res)) {
                return
            }
            this.$message({
                type: 'success',
                message: this.$t('account.successMotifyPassword') as string,
            })
            this.$emit('close')
        }
        withDialogLoading(this, buildTask())
    }

    onCancel() {
        this.$emit('close')
    }

    onClose() {
        this.$emit('close')
    }
}
